// extracted by mini-css-extract-plugin
module.exports = {"tile":"Tile_tile_1r_TP","mobile":"Tile_mobile_2o5Ew","tileText":"Tile_tileText_3u9-z"};